import React, { useEffect, useState } from "react";
import SunburstChart from "../../CHARTS/SunburstChart";
import SplineAreaChart from "../../CHARTS/SplineChart";
import Loading from "../../Extra/Loading";
import {
  formatDateToDis,
  getCurrentDate,
  getOnePreviousDate,
} from "../../Utilitie";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useGlobalContext } from "../../Context/GlobalContext";
import TooltipHeader from "../../Extra/TooltipHeader";
import StackedAreaChart from "../../CHARTS/StackedAreaChart";
const Punctuality = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const { setDateForGlobal, globalDate } = useGlobalContext();
  const [punctualityData, setPunctualityData] = useState();
  const [allPunctualityData, setAllPunctualityData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [mexpData, setmexpData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [dpChartData, setDpChartData] = useState([]);
  const [dateForDisplay, setDateForDisplay] = useState(null);
  const [date, setDate] = useState(null);
  const url = `${urlPrefix}ppservices/date?date=${date}`;
  // console.log(dpChartData.data);
  useEffect(() => {
    setDate(globalDate);
  }, [globalDate]);
  const fetchData = async (url) => {
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setPunctualityData(data?.latestData);
      setAllPunctualityData(data?.allData);
      data?.data?.map((mData, index) => {
        if (mData?.T_TYPE === "MEXP") {
          setmexpData(mData);
        }
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      setError(false);
    }
  };
  useEffect(() => {
    // const currentDate = getCurrentDate();
    const lastDayDate = getOnePreviousDate();
    setDate(lastDayDate);
  }, []);
  useEffect(() => {
    fetchData(url);
    // setDateForGlobal(date);
  }, [date]);

  const handleDateChange = (event) => {
    const inputDate = event.target.value; // YYYY-MM-DD
    setDate(inputDate);
    const [year, month, day] = inputDate.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    setDateForDisplay(formattedDate); // Outputs: DD-MM-YYYY
  };
  const order = ["MEXP", "PASS", "TOTAL", "TOD"]; // Define the fixed order
  const sortedData = punctualityData?.sort((x, y) => {
    return order?.indexOf(x.T_TYPE) - order?.indexOf(y.T_TYPE);
  });

  const filterDataByDate = (dataArray, givenDate) => {
    // Step 1: Filter data matching the given date
    let filteredData = dataArray?.filter((item) => item.PP_DATE === givenDate);

    // Step 2: If no match found, find the latest date
    if (filteredData?.length === 0) {
      // Find the latest date from available data
      const latestDate = dataArray
        ?.map((item) => item.PP_DATE)
        ?.sort((a, b) => new Date(b) - new Date(a))[0]; // Sorting in descending order

      // Filter data with the latest date
      filteredData = dataArray?.filter((item) => item.PP_DATE === latestDate);
    }

    return filteredData;
  };

  const filteredDataByDateByType = filterDataByDate(sortedData, date);
  useEffect(() => {
    if (allPunctualityData?.length) {
      // Convert UTC to local time and sort by date in ascending order (oldest first)
      const sortedData = [...allPunctualityData].sort(
        (a, b) => new Date(a.PP_DATE) - new Date(b.PP_DATE)
      );

      // Extract unique dates in ascending order
      const uniqueDates = Array.from(
        new Set(
          sortedData.map((entry) =>
            new Date(entry.PP_DATE).toLocaleDateString("en-GB", {
              timeZone: "Asia/Kolkata",
            })
          )
        )
      );

      // Group by T_TYPE and store { date, TODAY_CY } objects in order
      const groupedData = sortedData.reduce((acc, entry) => {
        let type = entry.T_TYPE.toUpperCase();
        if (type === "M/EXP") type = "MEXP"; // Normalize "M/EXP" to "MEXP"

        const formattedDate = new Date(entry.PP_DATE).toLocaleDateString(
          "en-GB",
          { timeZone: "Asia/Kolkata" }
        );

        if (!acc[type]) {
          acc[type] = { name: type, data: [] };
        }

        acc[type].data.push({
          date: formattedDate,
          TODAY_CY: entry.TODAY_CY,
        });

        return acc;
      }, {});

      // Convert grouped object to an array
      const chartDataArray = Object.values(groupedData);

      // Set state
      setChartData({ chartData: chartDataArray, uniqueDates });
    }
  }, [allPunctualityData]);

  const newChartData = (data) => {
    const chartData = data?.filter(
      (category) => category.name === "MEXP" || category.name === "PASS"
    );

    const transformedData = [];
    const dates =
      chartData[0]?.data?.map((entry) => entry?.date?.slice(0, 5)) || [];

    chartData?.forEach((category) => {
      transformedData.push({
        name: category.name,
        data: category.data.map((entry) => entry.TODAY_CY),
      });
    });

    return { data: transformedData, dates };
  };

  useEffect(() => {
    if (chartData.chartData) {
      setDpChartData(newChartData(chartData?.chartData));
    }
  }, [chartData]);
  return (
    <div className="">
      <div className="row    m-1">
        <div className="col-md-12" style={{ fontSize: "11px" }}>
          <div className="d-flex justify-content-between">
            <div>
              <h6> Punctuality Date :{formatDateToDis(globalDate)}</h6>
            </div>
          </div>
          <div className="row ">
            <div
              className="table-responsive"
              style={{ overflowX: "auto", overflowY: "hidden" }}
            >
              {/*  table-responsive */}
              <table
                className="table newUiTable table-striped  table-hover p-0 m-0"
                style={{ fontSize: "11px" }}
              >
                <thead className=" p-0 m-0">
                  <tr className="p-0 m-0">
                    {/* <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-1`}>Station</Tooltip>}
                    >
                      <th>JBP</th>
                    </OverlayTrigger> */}
                    <TooltipHeader
                      id={`tooltip-1`}
                      label="JBP"
                      tooltip="Station"
                    />
                    {/* <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-2`}>Scheduled</Tooltip>}
                    >
                      <th>Sch</th>
                    </OverlayTrigger> */}
                    <TooltipHeader
                      id={`tooltip-2`}
                      label="Sch"
                      tooltip="Scheduled"
                    />
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-3`}>Reported</Tooltip>}
                    >
                      <th>RPT</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-4`}>Before time</Tooltip>}
                    >
                      <th>BT</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-4`}>Right time</Tooltip>}
                    >
                      <th>RT</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-5`}>Mackup</Tooltip>}
                    >
                      <th>MKUP</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={
                        <Tooltip id={`tooltip-6`}>Not late/lost</Tooltip>
                      }
                    >
                      <th>NLT</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={
                        <Tooltip id={`tooltip-7`}>Late/ Lost Train</Tooltip>
                      }
                    >
                      <th>LT</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-8`}>TODAY</Tooltip>}
                    >
                      <th>TD</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-9`}>MONTH</Tooltip>}
                    >
                      <th>M</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-10`}>YEAR</Tooltip>}
                    >
                      <th>Y</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={
                        <Tooltip id={`tooltip-11`}>TODAY LAST YEAR</Tooltip>
                      }
                    >
                      <th>TD-LY</th>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-12`}>LAST YEAR</Tooltip>}
                    >
                      <th>LY</th>
                    </OverlayTrigger>
                    {/* <th >JBP</th>
                  <th >Sch</th>
                  <th >RPT</th>
                  <th >BT</th>
                  <th >RT</th>
                  <th >MKUP</th>
                  <th >NLT</th>
                  <th >LT</th>
                  {/* <th >ZoneL Loss</th> */}
                    {/* <th >TODAY</th>
                  <th >MONTH</th>
                  <th >YEAR</th>
                  <th >TODAY_LY</th>
                  <th >LY</th>  */}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr className="text-center">
                      <td colSpan={13} scope="col">
                        <Loading />
                      </td>
                    </tr>
                  ) : null}
                  {!punctualityData ? (
                    <tr className="text-center">
                      <td colSpan={13} scope="col">
                        No Data Found
                      </td>
                    </tr>
                  ) : null}
                  {!loading &&
                    punctualityData &&
                    filteredDataByDateByType.map((data, index) => {
                      if (data?.T_TYPE === "PASS" || data?.T_TYPE === "MEXP") {
                        return (
                          <tr key={index} className="p-0 m-0">
                            <td
                              style={{
                                background:
                                  data?.T_TYPE === "MEXP"
                                    ? "#00e600"
                                    : "#007bff",
                                color:
                                  data?.T_TYPE === "MEXP" ? "black" : "White",
                              }}
                            >
                              {data?.T_TYPE}
                            </td>
                            <td>{data?.SCH}</td>
                            <td>{data?.RPT}</td>
                            <td>{data?.BT}</td>
                            <td>{data?.RT}</td>
                            <td>{data?.MKUP}</td>
                            <td>{data?.NLT}</td>
                            <td>{data?.LT}</td>
                            <td>{data?.TODAY_CY}</td>
                            <td>{data?.UPTO_M_CY}</td>
                            <td>{data?.CY}</td>
                            <td>{data?.TODAY_LY}</td>
                            <td>{data?.LY}</td>
                          </tr>
                        );
                      }
                      if (data?.T_TYPE === "TOTAL") {
                        return (
                          <tr key={index} className="p-0 m-0">
                            <td>{data?.T_TYPE}</td>
                            <td>{data?.SCH}</td>
                            <td>{data?.RPT}</td>
                            <td
                              rowSpan={2}
                              colSpan={9}
                              scope="col"
                              style={{
                                padding: "0px",
                                border: "1px solid red",
                              }}
                            >
                              {dpChartData?.dates ? ( // hiding the chart so that it dont show any error if there is no chart data
                                <SplineAreaChart
                                  data={dpChartData?.data}
                                  categories={dpChartData?.dates}
                                  from={"Punctuality"}
                                />
                              ) : // <StackedAreaChart data={{series:dpChartData.data,categories:dpChartData?.dates}} />
                              null}
                            </td>
                            <td scope="col">{data?.LY}</td>
                          </tr>
                        );
                      }
                      if (data?.T_TYPE === "TOD") {
                        return (
                          <tr key={index} className="p-0 m-0">
                            <td>{data?.T_TYPE}</td>
                            <td>{data?.SCH}</td>
                            <td>{data?.RPT}</td>
                            <td>{data?.LY}</td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <div className="col-md-2">
          <SunburstChart data={sampleData} />
        </div> */}
      </div>
    </div>
  );
};
export default Punctuality;
